// libraries
import { useFormContext, Controller } from 'react-hook-form'
import { Box, Typography, Stack, Autocomplete, TextField, Checkbox as MuiCheckbox, Alert } from '@mui/material'

// helpers and utils
import { OUTBOUND_TICKET_STATUSES } from 'utils/constants'
import React from 'react'

interface PullApartRow {
  id?: string
  row: number
  numberOfVins: number
}

interface PullApartFormComponentProps {
  isFetchingPullApartScrapRows: boolean
  isLoading: boolean
  isUpdate: boolean
  ticketStatus: string
  activePullApartScrapRows: PullApartRow[]
  disabled: boolean
  pullApartRemovedRowsMessage: string
}

const PullApartFormComponent: React.FC<PullApartFormComponentProps> = ({
  isFetchingPullApartScrapRows,
  isLoading,
  isUpdate,
  ticketStatus,
  activePullApartScrapRows,
  disabled,
  pullApartRemovedRowsMessage,
}) => {
  const { control, getValues } = useFormContext()

  return (
    <Box p={3}>
      <Typography variant="h6" gutterBottom color="textSecondary">
        Scrap Rows
      </Typography>
      <Stack
        padding={2}
        spacing={2}
        sx={{
          backgroundColor: 'background.section',
          borderRadius: '8px',
        }}
      >
        {pullApartRemovedRowsMessage && (
          <Alert severity="info" sx={{ width: { xs: '100%', md: '50%' } }}>
            {pullApartRemovedRowsMessage}
          </Alert>
        )}
        <Stack spacing={2} direction={{ xs: 'column', md: 'row' }}>
          <Stack direction="row" spacing={2} width={{ xs: '100%', md: '50%' }}>
            {isLoading || !isUpdate || ticketStatus === OUTBOUND_TICKET_STATUSES.INCOMPLETE.id ? (
              <Controller
                name="pullApartRows"
                control={control}
                render={({ field: { onChange } }) => (
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    fullWidth
                    data-test="pull-apart-row-ids"
                    size="small"
                    options={activePullApartScrapRows}
                    disabled={disabled}
                    value={getValues('pullApartRows') || []}
                    renderInput={params => <TextField {...params} />}
                    getOptionLabel={option => `${option.row} (${option.numberOfVins} vehicles)`}
                    renderOption={(props, option, { selected }) => (
                      <li {...props} style={{ padding: 0 }} key={option.row}>
                        <MuiCheckbox style={{ marginRight: 8 }} checked={selected} />
                        {`${option.row} (${option.numberOfVins} vehicles)`}
                      </li>
                    )}
                    isOptionEqualToValue={(option, value) => Number(option.row) === Number(value.row)}
                    onChange={(_, selectedOptions) => onChange(selectedOptions)}
                  />
                )}
              />
            ) : (
              <Typography variant="body2">
                {isFetchingPullApartScrapRows
                  ? 'Loading...'
                  : `${(getValues('pullApartRows') || []).reduce((aggregate, row) => aggregate + Number(row.numberOfVins), 0)} Vehicles`}
              </Typography>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  )
}
export default PullApartFormComponent
